import { computed, onMounted, ref } from 'vue';
import { getCachedGeo, loadVisitorGeo } from '@/services/geo';

export const displayCurrencyRef = ref(getCachedGeo()?.display_currency || 'EUR');
export const visitorCountryRef = ref(getCachedGeo()?.country_code || null);
export const isSpainRef = ref(getCachedGeo()?.is_spain ?? false);

let loadInflight = null;

export function loadDisplayCurrency() {
  if (loadInflight) return loadInflight;

  loadInflight = loadVisitorGeo()
    .then((geo) => {
      displayCurrencyRef.value = geo.display_currency || 'EUR';
      visitorCountryRef.value = geo.country_code || null;
      isSpainRef.value = Boolean(geo.is_spain);
      return geo;
    })
    .catch(() => {
      displayCurrencyRef.value = 'EUR';
      visitorCountryRef.value = null;
      isSpainRef.value = false;
      return null;
    })
    .finally(() => {
      loadInflight = null;
    });

  return loadInflight;
}

export function useDisplayCurrency() {
  onMounted(() => {
    loadDisplayCurrency();
  });

  const displayCurrency = computed(() => displayCurrencyRef.value || 'EUR');
  const visitorCountry = computed(() => visitorCountryRef.value);
  const isSpain = computed(() => isSpainRef.value);

  return {
    displayCurrency,
    visitorCountry,
    isSpain,
    loadDisplayCurrency,
  };
}
